module.exports = {
          srcSet: __webpack_public_path__ + "public/74dc747025c36fe43fc48ff3be52fce2-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/74dc747025c36fe43fc48ff3be52fce2-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/74dc747025c36fe43fc48ff3be52fce2-80.png",
          toString:function(){return __webpack_public_path__ + "public/74dc747025c36fe43fc48ff3be52fce2-80.png"},
          
          width: 80,
          height: 80
        }